angular.
module("dx.webapp.grade").
factory("DxGrade", function dxGrade(
	DX_GRADING_TYPES,
	BlockGrading
) {
	"use strict";

	var gradeDefaults = {
		examId: null,
		questionId: null,
		studentId: null,
		gradingType: null,
		score: null,
		isScoreSet: false,
		grade: "",
		abilityGrades: [],
		note: "",
		blockGradings: [],
		finalGradeType: 0,

		isGraded: function isGraded() {
			switch (this.gradingType) {
				case DX_GRADING_TYPES.SCORE:
					return typeof this.score === "number";
				case DX_GRADING_TYPES.FORMATIVE:
					return this.hasSummarizedAssessment();
				default:
					throw new Error("Checking isGraded on unsupported gradingType:" + this.gradingType);
			}
		},
		hasSummarizedAssessment: function hasSummarizedAssessment() {
			return !!this.grade && typeof this.grade === "string";
		},
		isAbilityGraded: function isAbilityGraded(abilityIndex) {
			var grade = this.abilityGrades[abilityIndex];
			return typeof grade === "number" && grade > 0;
		},
		getAnnotations: function getAnnotations(includeEmpty) {
			var annotations = [];

			if (this.blockGradings) {
				for (var i = 0; i < this.blockGradings.length; i++) {
					var blockGrading = this.blockGradings[i];
					if (blockGrading.annotations) {
						for (var j = 0; j < blockGrading.annotations.length; j++) {
							var annotation = blockGrading.annotations[j];
							var hasContent = (annotation.comment || annotation.points);

							if (includeEmpty || hasContent) {
								annotations.push(annotation);
							}
						}
					}
				}
			}


			return annotations;
		},
	};

	function Grade(data) {
		angular.extend(this, gradeDefaults, data);

		// Convert 0 score to null if the score is not set
		// due to lack of nullables in the API
		if (!this.isScoreSet && this.score === 0) {
			this.score = null;
		}

		// blockGradings can be null from the backend
		if (this.blockGradings === null) {
			this.blockGradings = [];
		}

		for (var i = 0; i < this.blockGradings.length; i++) {
			this.blockGradings[i] = new BlockGrading(this.blockGradings[i]);
		}
	}

	return Grade;
});
